










import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { Message } from 'element-ui';
import SearchPaginationTable from '@/components/search-pagination-table.vue';
import http from '../unite/http';
import { post } from '@/unite/api';
import Dialog from '@/components/dialog.vue';
@Component({
  components: { SearchPaginationTable, Dialog }
})
export default class DialogTable extends Vue {
  @Prop() form: any;
  dialogVisible: boolean = true;
  numWidth: string = '80%';
  pageData: any = {
    url: '',
    isSearch: false, // 是否需要搜索框
    isPagination: true, // 是否后端分页
    isBtn: true, // 是否需要头部操作按钮
    info: {}, // 传后端数据
    searchData: [],
    btnData: [
      {
        name: '导出列表',
        methods: 'downAll',
        type: 'downAll',
        loading: false
      }
    ],
    tableData: {
      stripe: true,
      border: true,
      expandShow: false,
      optionShow: false,
      header: [],
      expand: [],
      option: []
    } // table
  };
  created() {
    this.pageData.url = this.form.url;
    this.pageData.info = this.form.info;
    this.pageData.tableData.header = this.form.header;
    if (this.form.isPagination === false) {
      this.pageData.isPagination = false;
    } else {
      this.pageData.isPagination = true;
    }
  }
  // 取消
  cancel() {
    this.$emit('refesh', false);
  }
  // 刷新列表
  refesh(bool: boolean) {
    if (bool) {
      // @ts-ignore
      this.$refs.table.getData();
    }
  }
}
